export default "__VITE_ASSET__2tJcft3e__"